/**
 * Generated bundle index. Do not edit.
 */
export { MatPaginatorModule, PageEvent, MatPaginator, MatPaginatorIntl } from './public-api';
//# sourceMappingURL=index.js.map